import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms'
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../auth/auth.service';
import { SharedService } from '../shared/shared.service';
import { DASHBOARD_TYPES } from '../_models/dashboardTypes';
@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor(private _router: Router, private _uiService: SharedService, private _cookieService: CookieService, private _auth: AuthService) { }

  static isDecimal(): ValidatorFn {
    return (control: FormControl): { [key: string]: boolean } | null => {
      let val: string = control.value;

      if (control.pristine) return null

      const regex = new RegExp("^([1-9]+\\d*([.]\\d+)?)$|^(0[.]\\d*[1-9]+)$|^0$")
      const status = regex.test(val)

      return { 'isDecimal': status };
    }
  }

  async checkDashPrevilegesGuard(dashboard) {
    try {
      let response = await this._auth.getDefaultDashboardGuard(this._cookieService.get('userid'))
      if (response && response['status'] && response['result'] && response['result'].length > 0) {
        let prevData = response['result'];
        return prevData.some(element => element.dashboard == dashboard);
      }
      return true;
    } catch (e) {
      console.error('Check dash privileges guard error:', e);
      return true;
    }
  }

  async gotoDefaultDashboardGuard() {
    try {
      var DFLAG = false
      let response = await this._auth.getDefaultDashboardGuard(this._cookieService.get('userid'))
      if (response && response['status'] && response['result'] && response['result'].length > 0) {
        let prevData = response['result'];
        DASHBOARD_TYPES.forEach(item => {
          prevData.forEach(element => {
            if (element.dashboard == item.previlege && element.defaultflag == 'Y') {
              this._router.navigate([item.path]);
              DFLAG = true
            }
          });
        });
        if (!DFLAG) this._uiService.openSnackBar('No default dashboard found', 'OK')
      }
    } catch (e) {
      console.error('Goto default dashboard guard error:', e);
    }
  }
}
